import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';
import type { AutorizaceState } from './store.types';
import type { AutorizaceSluzbaAutorizaceDto } from '@gov-nx/api';

const initialState = {
	servicesList: [],
};

const useStore = <T>(selector: (state: AutorizaceState) => T) =>
	usePersistedStore(
		(set, get) => ({
			...initialState,
			servicesListReset: () => set({ servicesList: [] }),
			setServicesList: (list: AutorizaceSluzbaAutorizaceDto[]) => {
				set({
					servicesList: list,
				});
			},
			getServiceAuthorizationType: (serviceName: string) =>
				get().servicesList.find((s) => s.kodSluzby === serviceName)
					?.typAutorizace,
		}),
		'authorization',
		selector
	);

export const useAutorizaceStore = <T extends keyof AutorizaceState>(
	property: T
): AutorizaceState[T] => useStore(prop(property));
